module.exports = Player;


//////////////////
// WEBPACK FOOTER
// external "Player"
// module id = QIKc
// module chunks = 3